/**
 * Helper functions for managing last selected car in localStorage
 * Used for smart auto-navigation between Garage and Dashboard
 */

const LAST_CAR_KEY = 'myCarCosts_lastSelectedCar';

/**
 * Get the slug of the last selected car from localStorage
 */
export function getLastSelectedCarSlug(): string | null {
    try {
        return localStorage.getItem(LAST_CAR_KEY);
    } catch (error) {
        console.error('Error reading last selected car from localStorage:', error);
        return null;
    }
}

/**
 * Save the slug of the selected car to localStorage
 */
export function setLastSelectedCarSlug(slug: string): void {
    try {
        localStorage.setItem(LAST_CAR_KEY, slug);
    } catch (error) {
        console.error('Error saving last selected car to localStorage:', error);
    }
}

/**
 * Clear the last selected car from localStorage
 * Should be called on logout
 */
export function clearLastSelectedCarSlug(): void {
    try {
        localStorage.removeItem(LAST_CAR_KEY);
    } catch (error) {
        console.error('Error clearing last selected car from localStorage:', error);
    }
}

/**
 * Determine if a car slug is valid (exists in the provided list)
 */
export function isValidCarSlug(slug: string | null, carSlugs: string[]): boolean {
    if (!slug) return false;
    return carSlugs.includes(slug);
}
